import React from 'react';
import styles from './elementaryPerformance.module.css';
import logo from '../../assets/mtc logo.png';
import EllipseSvg from '../../svgs/EllipseSvg';
import defaultPic from '../../assets/avatar.png';
import { ChallengeMode } from '../../types/enums';
import { useGameSocket } from '../../providers/gameSocket.provider';
import { useNavigate, useParams } from 'react-router-dom';
import { Round } from '../../types/Round';
import { ProjectLeaderboardPayload, RoundReview } from '../../types/RoundReview';
import { roundUp } from '../../utils/mathUtils';
import WaitingForHost from '../../components/WaitingForHostLoader';

const ElementaryPerformanceScreen: React.FC<any> = ()=>{

    // Ref
    let isRendered = React.useRef<boolean>(false);

    // Hooks
    const { gameSocket } = useGameSocket();
    const { rid } = useParams();
    const navigate = useNavigate();


    // State
    const [inReview, setInReview] = React.useState<boolean>(true);
    const [round, setRound] = React.useState<Round>()

    // Subs and unsubs
    const subscribe = ()=>{
        gameSocket?.on('connect', ()=>{
            console.log("SOCKET CONNECTED")
            if (rid) {
                console.log("CONNECTED RID")
                gameSocket.emit('join-round', rid)
            }
        })
        gameSocket?.on('project-leaderboard', ({ competitionId }: ProjectLeaderboardPayload)=>{
            navigate(`/leaderboard?cid=${competitionId}`)
        })

        gameSocket?.on('show-preview', ({ show, round }: RoundReview)=>{
            console.log(show);
            setRound(round)
            setInReview(!show);
        })

    }
    const unsubscribe = ()=>{
        gameSocket?.removeAllListeners()
    }

    // Effects
    React.useEffect(()=>{
        if (!isRendered.current) {
            subscribe();
            isRendered.current = true
        }

        // return unsubscribe
    }, [])

    // Metrics
    let qPerSecond = (round?.questionsAnswered || 0)/(round?.rule?.maxTime || 0);
    let qPerSecondSuddenDeath = (round?.questionsAnswered || 0)/(round?.actualTime || 1);

    // Helpers
    const getQuestionPerSecond = ()=>{
        if (round?.mode === ChallengeMode.SUDDEN_DEATH) {
            return qPerSecondSuddenDeath;
        }

        return qPerSecond;
    }

    const getGameTime = ()=>{
        if (round?.mode === ChallengeMode.SUDDEN_DEATH) {
            return round?.actualTime;
        }

        return round?.actualTime;
    }

    // Elements

    const mtclogo = (
        <div className={styles.logo}>
            <img src={logo} alt="MTC logo" />
        </div>
    );
    
    const statsDisplay = (
        <div className={styles.statDisplay}>
            <div className={styles.name}>
                <p>{`${round?.player?.firstname} \n`}</p>
                <p>{`${round?.player?.lastname}`}</p>
                <hr />
                {round?.player?.grade} GRADE
            </div>
            <div className={styles.stat}>
                <p>{`${round?.questionsAnswered} \n`}</p>
                <p>Questions in {getGameTime()}s</p>
                <hr />
            </div>
            <div className={styles.stat}>
                <p>{`${roundUp(getQuestionPerSecond())} \n`}</p>
                <p>Questions per second</p>
                <hr />
            </div>
            <div className={styles.stat}>
                <p>{`${round?.answeredCorrect} \n`}</p>
                <p>Correct Answers</p>
                <hr />
            </div>
            {
                round?.mode === ChallengeMode.FIXED_TIME &&
                <div className={styles.stat}>
                    <p>{`${round?.answeredWrong} \n`}</p>
                    <p>Incorrect Answers</p>
                    <hr />
                </div>
            }
            <div className={styles.stat}>
                <p>{`${((round?.answeredCorrect && round?.questionsAnswered) && (round?.answeredCorrect/round?.questionsAnswered) * 100)?.toFixed(0)}% \n`}</p>
                <p>Accuracy</p>
                <hr />
            </div>
            <div className={styles.stat}>
                <p>{`${round?.score} \n`}</p>
                <p>Score</p>
            </div>
            {/* <div className={styles.stat}>
                <p>{`200 \n`}</p>
                <p>Questions/ Min</p>
            </div> */}
        </div>
    );

    const displayPicture = (
        <div className={styles.displayPic}>
            <div className={styles.profile}>
                <img src={round?.player && round?.player.image ? round.player.image.url : defaultPic} 
                alt="MTC Contestant image" />
            </div>
            <EllipseSvg className={styles.ellipse}/>
        </div>
    )

    if (inReview) {
        return(
            <div className={styles.container}>
                <div className={styles.title}>
                    <h4>Performance Summary</h4>
                </div>
                <WaitingForHost/>
        </div>
        )
    }

    return(
        <div className={styles.container}>
             <div className={styles.title}>
                <h4>Performance Summary ({round?.name})</h4>
            </div>
            <div className={`${styles.main}`}>
                {/** Logo */}
                <div className={styles.logoArea}>
                    {mtclogo}
                </div>

                {/** Stats Display */}
                { statsDisplay }

                {/** Player Display Picture */}
                { displayPicture }
            </div>

        </div>
    )
}

export default ElementaryPerformanceScreen;